import React from 'react';
import { useRealtime } from '../../contexts/RealtimeContext';
import TeacherManagement from '../../components/coaching/TeacherManagement';
import { isCoachingAdmin as checkIsCoachingAdmin } from '../../utils/rbac';

const CoachingTeacherManagement = () => {
  const { userProfile, currentUser } = useRealtime();
  const isCoachingAdmin = checkIsCoachingAdmin(userProfile, currentUser);
  
  // Get coaching ID from user profile - prioritize coachingId field
  const coachingId = userProfile?.coachingId || 
                    (isCoachingAdmin ? userProfile?.id : null) ||
                    (isCoachingAdmin ? currentUser?.uid : null);
  
  console.log('CoachingTeacherManagement - coachingId:', coachingId, 'userProfile:', userProfile, 'role:', userProfile?.role);
  
  // Show loading if user profile is not loaded yet
  if (!userProfile) {
    return (
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm p-6">
        <div className="flex items-center justify-center min-h-[400px]">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
        </div>
      </div>
    );
  }
  
  const isAdmin = userProfile?.role === 'admin' || userProfile?.role === 'superadmin' || userProfile?.role === 'founder';
  const hasTeacherSection = userProfile?.role === 'coaching_admin' || userProfile?.accessibleSections?.includes('teachers');
  const canView = isAdmin || (isCoachingAdmin && hasTeacherSection);

  // Show error if user is not a coaching admin/staff with teacher section, or superadmin/admin
  if (!canView) {
    return (
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm p-6">
        <div className="text-center py-12">
          <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">
            Access Denied
          </h3>
          <p className="text-gray-600 dark:text-gray-400">
            You don't have permission to access teacher management.
          </p>
        </div>
      </div>
    );
  }
  
  return <TeacherManagement coachingId={coachingId} />;
};

export default CoachingTeacherManagement;